import { useContext } from "react";
import NoteGridPanel from "../../../common/notes/components/NoteGridPanel";
import { EstimateContext } from "../context/EstimateContext";

export default function EstimateNotesPanel(props: { height?: string | number }) {

	const { order } = useContext(EstimateContext);

	return (
		<NoteGridPanel
			notes={order.details.notes}
			height={props.height}
		/>
	)
}
